import { render, staticRenderFns } from "./edit_accessory.vue?vue&type=template&id=d608b6de&"
import script from "./edit_accessory.vue?vue&type=script&lang=js&"
export * from "./edit_accessory.vue?vue&type=script&lang=js&"
import style0 from "./edit_accessory.vue?vue&type=style&index=0&id=d608b6de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports